import { useEffect, useRef, useState } from 'react'
import { Container } from 'react-grid-system'
import parse from 'html-react-parser'

import { Button } from '~elements'
import { ButtonProps } from '~types'

import styles from './NotificationBanner.module.scss'

interface NotificationBannerProps {
  copy: { html: string }
  ctaPrimary?: ButtonProps
  showBanner: boolean
}

const NotificationBanner = ({ copy, ctaPrimary, showBanner }: NotificationBannerProps) => {
  const ref = useRef(null)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const el = ref.current

    if (!el) return

    const updateHeight = () => {
      const measuredHeight = el.offsetHeight
      setHeight(measuredHeight)
    }

    updateHeight()

    const observer = new ResizeObserver(() => {
      updateHeight()
    })

    observer.observe(el)

    return () => observer.disconnect()
  }, [])

  if (showBanner) {
    return (
      <>
        <div ref={ref} className={styles['notification-banner']} id="notification-banner">
          <div className={styles.container}>
            <div className={styles['notification_banner__content']}>
              <div className={styles['notification_banner__text']}>{copy?.html && parse(copy.html)}</div>
              {ctaPrimary && (
                <div className={styles['notification_banner__button']}>
                  <Button {...ctaPrimary} />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Spacer to push down page content to prevent overlapping. */}
        <div style={{ height: height }} />
      </>
    )
  } else {
    return <div className={styles['notification-banner']} id="notification-banner" />
  }
}
export default NotificationBanner
